import React from 'react';
import { GridViewSharp, ViewListSharp } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ViewToggle = ({ viewMode, setViewMode, listLabel, gridLabel }) => {
  const { t } = useTranslation();
  const gridText = gridLabel || t('SearchJob.Grid', { defaultValue: 'Grid' });
  const listText = listLabel || t('SearchJob.List', { defaultValue: 'List' });

  return (
    <div className="job-view-toggle" role="group" aria-label={t('SearchJob.ViewLayout', { defaultValue: 'Job view layout' })}>
      <button
        type="button"
        className={`${viewMode === 'grid' ? 'active' : ''}`}
        onClick={() => setViewMode('grid')}
        title={t('SearchJob.Grid view', { defaultValue: 'Grid view' })}
        aria-pressed={viewMode === 'grid'}
        aria-label={t('SearchJob.Grid view', { defaultValue: 'Grid view' })}
      >
        <GridViewSharp style={{ fontSize: '18px' }} />
        <span className="d-none d-sm-inline">{gridText}</span>
      </button>
      <button
        type="button"
        className={`${viewMode === 'list' ? 'active' : ''}`}
        onClick={() => setViewMode('list')}
        title={t('SearchJob.List view', { defaultValue: 'List view' })}
        aria-pressed={viewMode === 'list'}
        aria-label={t('SearchJob.List view', { defaultValue: 'List view' })}
      >
        <ViewListSharp style={{ fontSize: '18px' }} />
        <span className="d-none d-sm-inline">{listText}</span>
      </button>
    </div>
  );
};

export default ViewToggle;
